import React from "react";
import { Entity } from "@ifgengineering/client-invest-sdk";
import { EntityBadge } from "@components/EntityBadge/EntityBadge.component";

export const createEntityBadgeIcon = (entity?: Entity): JSX.Element => {
  return (
    <EntityBadge
      entity={entity}
      hideInfo={true}
      iconConfig={{
        size: 14,
        showLabel: false,
      }}
      displayNameConfig={{
        hide: true,
      }}
    />
  );
};
